import * as preact from 'preact'
const { h, Component } = preact
import * as styles from './style.css'
import PureComponent from '../../lib/preact-pure-component'
import { Timing } from './timing'
import { Text } from './text'
import { Intro } from './intro'
import { Blockquote } from './blockquote'
import { Byline } from './byline'
import { LinkOut } from './linkout'
import { Map } from './map'
import { Chapter } from './chapter'
import { BylineInline } from './bylineinline'
import classNames from 'classnames'
interface Props {
  addIntersectionElement: (el: HTMLElement) => void
  id: string
  active: boolean
  type: string
  blocks: Block[]
  style?: string
  preload: boolean
  shadowColor?: string
  noShadow: boolean
  align?: string
}

interface Block {
  text?: string
  type: string
  title?: string
  lead?: string
  style?: string
  source?: string
}

function getComponentForType(type: string) {
  switch (type) {
    case 'intro-block':
      return Intro
    case 'text':
      return Text
    case 'blockquote':
      return Blockquote
    case 'byline':
      return Byline
    case 'linkout':
      return LinkOut
    case 'map':
      return Map
    case 'chapter':
      return Chapter
    case 'bylineinline':
      return BylineInline
    default:
      return Text
  }
}

export class Foreground extends PureComponent<Props, {}> {
  wrapper?: HTMLDivElement

  componentDidMount() {
    if (this.wrapper) {
      this.props.addIntersectionElement(this.wrapper)
    }
  }
  render() {
    const { id, blocks, style } = this.props

    const className = classNames(styles.foreground, {
      [styles.introCard]: style && style.indexOf('intro') > -1,
      [styles.lessMarginBottom]: style && style.indexOf('lessMarginBottom') > -1,
      [styles.lessMarginTop]: style && style.indexOf('lessMarginTop') > -1
    })

    const innerWrapper = classNames(styles.innerWrapper, {
      [styles.left]: this.props.align === 'left',
      [styles.right]: this.props.align === 'right',
      [styles.intro]: style && style.indexOf('intro') > -1
    })

    const mappedBlocks = blocks.map((block, idx) => {
      const { type, ...props } = block
      const noShadow = this.props.noShadow || (block.style && block.style.indexOf('noShadow') > -1)
      const Component = getComponentForType(type)
      return [
        <Component
          addIntersectionElement={this.props.addIntersectionElement}
          backgroundType={this.props.type}
          key={`${id}-${idx}`}
          id={id}
          active={this.props.active}
          preload={this.props.preload}
          shadowColor={this.props.shadowColor}
          noShadow={noShadow}
          {...props}
        />,
        <Timing
          key={`${id}-tail-${idx}`}
          id={id}
          source={block.source}
          addIntersectionElement={this.props.addIntersectionElement}
        />
      ]
    })

    return (
      <div className={className} id={id} ref={el => (this.wrapper = el)}>
        <div className={innerWrapper}>{mappedBlocks}</div>
      </div>
    )
  }
}
